import React from 'react';
import { 
  XCircleIcon,
  XMarkIcon
} from '@heroicons/react/24/outline';
import QualityAnalysisSuccess from './QualityAnalysisSuccess';

interface QualityAnalysisModalProps {
  isOpen: boolean;
  onClose: () => void;
  type: 'success' | 'error';
  qualityDecision?: 'ACCEPTE' | 'ACCEPTE_RESERVE' | 'REFUSE';
  message?: string;
  onContinue?: () => void;
  onFinish?: () => void;
}

const QualityAnalysisModal: React.FC<QualityAnalysisModalProps> = ({
  isOpen,
  onClose,
  type,
  qualityDecision,
  message,
  onContinue,
  onFinish
}) => {
  if (!isOpen) return null;

  const getModalContent = () => {
    if (type === 'success' && qualityDecision) {
      return (
        <QualityAnalysisSuccess
          qualityDecision={qualityDecision}
          onContinue={onContinue || (() => {})}
          onFinish={onFinish || (() => {})}
          className="p-0"
        />
      );
    }

    if (type === 'error') {
      return (
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
            <XCircleIcon className="h-6 w-6 text-red-600" />
          </div>
          <h3 className="text-lg font-medium text-gray-900 mb-2">
            Erreur lors de l'enregistrement
          </h3>
          <p className="text-sm text-gray-600 mb-6">
            {message || 'Une erreur est survenue lors de l\'enregistrement de l\'analyse qualité.'}
          </p>
          
          <button
            onClick={onClose}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors focus:outline-none focus:ring-2 focus:ring-red-500"
          >
            Fermer
          </button>
        </div>
      );
    }
  };

  return (
    <div className="fixed inset-0 z-[10000] overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        {/* Background overlay */}
        <div 
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          onClick={onClose}
        ></div>

        {/* Modal panel */}
        <div className={`inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:w-full ${
          type === 'success' ? 'sm:max-w-2xl' : 'sm:max-w-lg'
        }`}>
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4 relative">
            {/* Close button */}
            <div className="absolute top-0 right-0 pt-4 pr-4 z-10">
              <button
                onClick={onClose}
                className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <XMarkIcon className="h-6 w-6" />
              </button>
            </div>
            
            {getModalContent()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default QualityAnalysisModal;
